import { render, staticRenderFns } from "./PersonalSanctions.vue?vue&type=template&id=3fb5738e&scoped=true"
import script from "./PersonalSanctions.vue?vue&type=script&lang=js"
export * from "./PersonalSanctions.vue?vue&type=script&lang=js"
import style0 from "./PersonalSanctions.vue?vue&type=style&index=0&id=3fb5738e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb5738e",
  null
  
)

export default component.exports